<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormRecubrimiento" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objRecubrimiento.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">    
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objRecubrimiento.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Tipo">Tipo</label>
                            <select v-model="objRecubrimiento.Tipo" class="form-control-search form-select">
                                <option value="">Seleccione una opción</option>
                                <option value="Interno">Interno</option>
                                <option value="Externo">Externo</option>
                            </select>
							<CValidation v-if="this.errorvalidacion.Tipo" :Mensaje="'*'+errorvalidacion.Tipo[0]"/>
						</div>
					</div>

                    <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <label class="form-label" for="Logo">Logo</label>
                            <div class="avatar-upload">
                                <div class="avatar-edit">
                                    <input id="logoImg" type="file" name="Logo" @change="$uploadImagePreview($event,ValidElement,Array('Img','imagePreview'))" ref="logoImg" accept=".png, .jpg, .jpg">
                                    <label for="logoImg"></label>
                                </div>
                                <div class="avatar-preview">
                                    <div id="imagePreview" :style="'background-image:url('+RutaFile+objRecubrimiento.Logo+');'" :src="RutaFile+objRecubrimiento.Logo"></div>
                                </div>
                            </div>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

import Configs      from'@/helpers/VarConfig.js';
export default {
    name: 'FormRecubrimiento',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objRecubrimiento: {
				IdRecubrimiento: 0,
				Nombre: '',
				Clave: '',
				Logo: '',
				Tipo: '',
				
            },
            ValidElement:Configs.validImage2m,
            RutaFile:'',
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			let formData = new FormData();
            let logoFile = '';
            if(this.$refs.logoImg.files[0]!=null){
                logoFile = this.$refs.logoImg.files[0];
            }

			formData.set('IdRecubrimiento', this.objRecubrimiento.IdRecubrimiento);
			formData.set('Nombre', this.objRecubrimiento.Nombre);
			formData.set('Clave', this.objRecubrimiento.Clave);
			formData.append('Logo', logoFile);
            formData.set('LogoOld', this.objRecubrimiento.Logo);
			formData.set('Tipo', this.objRecubrimiento.Tipo);
			
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
			
			await this.$http.post('recubrimientos', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "recubrimientos/"+this.objRecubrimiento.IdRecubrimiento
            ).then((res) => {
                this.objRecubrimiento = res.data.data;
                this.RutaFile         = res.data.rutaFile;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objRecubrimiento.Fecha.replace(/-/g,'\/');
                this.objRecubrimiento.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objRecubrimiento = {
				IdRecubrimiento: 0,
				Nombre: '',
				Clave: '',
				Logo: '',
				Tipo: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objRecubrimiento.IdRecubrimiento = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
